import "./insMapLegend.scss";
import React, { Fragment } from "react";
import { useDispatch } from "react-redux";
import { useUnSelectedLegends, useWidgetComponentProps } from "components/widgets/hooks/use-current-widget";
import { setCurrentStatusUnselectedLegends } from "store/current-dashboard";
export const InsMapLegend = (props) => {
    const { widgetId, items, sectionId } = props, unSelectedLegends = useUnSelectedLegends(sectionId, widgetId), unSelectedLegendsRecord = unSelectedLegends?.reduce((prev, curr) => {
        prev[curr] = curr;
        return prev;
    }, {}), { colorSet } = useWidgetComponentProps(sectionId, widgetId);
    const dispatch = useDispatch(), handleLegendClick = (legendName) => {
        dispatch(setCurrentStatusUnselectedLegends({ legendName, sectionId, selected: Boolean(unSelectedLegendsRecord?.[legendName]), widgetId }));
    };
    return React.createElement("div", { className: `ins-map-legend-container ${colorSet}-ins-map-legend` }, items.map((value, index) => {
        const variableClass = unSelectedLegendsRecord?.[value] ? "ins-map-legend-unselected" : `highcharts-color-${index}`;
        return React.createElement(Fragment, { key: `fragment-${index}` },
            React.createElement("div", { className: `ins-map-legend-box ${variableClass}`, onClick: () => handleLegendClick(value) }),
            React.createElement("span", null, value));
    }));
};
